import { IComment } from 'interface/forum';
import { ICommentInformations } from '../interface/forum';
import { get, post, del, put } from 'services/apiForum';
import { getUrlParams } from 'utils';
import NotFound from 'components/Shared/Error/NotFound';
import Forbidden from 'components/Shared/Error/Forbidden';

import ServerError from '../components/Shared/Error/ServerError/index';

const paramsUrl = getUrlParams();

export const errorComponents: Map<number, any> = new Map([
  [
    404,
    () => {
      return <NotFound />;
    },
  ],
  [
    403,
    () => {
      return <Forbidden />;
    },
  ],
  [
    500,
    () => {
      return <ServerError />;
    },
  ],
]);

//actions
export const select = (data: any) => ({
  type: 'SELECT_TOPIC',
  data,
});

export const sendCommentary = (comment: Partial<ICommentInformations>) => ({
  type: 'SEND_COMMENT',
  comment,
});

export const removeCommentary = (id: number) => ({
  type: 'REMOVE_COMMENT_FORUM',
  id,
});

export const editingComment = (id: number) => ({
  type: 'EDITING_COMMENT',
  id,
});

export const confirmationEdition = (comment: any) => ({
  type: 'EDIT_COMMENT',
  comment,
});

export const moderateComment = (comment: any) => ({
  type: 'MODERATE',
  comment,
});

export const loadComments = (comments: IComment[]) => ({
  type: 'LOAD_COMMENTS',
  comments,
});

export const loader = () => ({
  type: 'LOADER',
});

export const activeError = (statusError: any) => ({
  type: 'ACTIVE_ERROR',
  statusError,
});

export const loadTopicInformations = (params: any) => {
  return async (dispatch: Function) => {
    try {
      dispatch(loader());

      const topicInformations = await get({ url: `/content/${paramsUrl.contentId}/threads/${params.id}` });

      const comments: any = await get({
        url: `/content/${paramsUrl.contentId}/threads/${params.id}/replies?page=${paramsUrl.page}`,
      });

      dispatch(select(topicInformations.data));
      dispatch(loadComments(comments.data));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};

export const sendComment = (comment: Partial<ICommentInformations>) => {
  return async (dispatch: Function) => {
    try {
      dispatch(loader());
      let newComment: any = await post({
        url: `/content/${paramsUrl.contentId}/threads/${comment.thread_id}/replies`,
        data: { text: comment.text },
      });
      dispatch(sendCommentary(newComment.data));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};

export const edit = (id: number) => {
  return async (dispatch: Function) => {
    try {
      dispatch(editingComment(id));
    } catch (err) {
      throw err;
    }
  };
};

export const removeComment = (id: number) => {
  return async (dispatch: Function) => {
    try {
      dispatch(loader());
      await del({ url: `/content/${paramsUrl.contentId}/replies/${id}` });

      dispatch(removeCommentary(id));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};

export const confirmEdition = (comment: Partial<ICommentInformations>) => {
  return async (dispatch: Function) => {
    try {
      dispatch(loader());

      const editedComment = await put({
        url: `/content/${paramsUrl.contentId}/replies/${comment.id}`,
        data: { text: comment.text },
      });

      dispatch(confirmationEdition(editedComment.data));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};

export const moderate = (id: number) => {
  return async (dispatch: Function) => {
    try {
      dispatch(loader());

      const moderatedComment = await put({ url: `/content/${paramsUrl.contentId}/replies/${id}/moderate` });

      dispatch(confirmationEdition(moderatedComment.data));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};

export const nextPage = (urlNextPage: string, actionType: string) => {
  return async (dispatch: Function) => {
    try {
      let comments: any = undefined;
      dispatch(loader());
      if (actionType === 'next_page') {
        comments = await get({ url: `/content/${paramsUrl.contentId}/thread${urlNextPage.split('thread')[1]}` });
      }

      if (actionType === 'last_page') {
        comments = await get({ url: `/content/${paramsUrl.contentId}/thread${urlNextPage.split('thread')[1]}` });
      }

      if (actionType === 'prev_page') {
        comments = await get({ url: `/content/${paramsUrl.contentId}/thread${urlNextPage.split('thread')[1]}` });
      }

      if (actionType === 'first_page') {
        comments = await get({ url: `/content/${paramsUrl.contentId}/thread${urlNextPage.split('thread')[1]}` });
      }

      dispatch(loadComments(comments.data));
    } catch (err) {
      dispatch(activeError(err.status));
      throw err;
    }
  };
};
